// extracted by mini-css-extract-plugin
export default {"page":"RY-z","cartModal":"SY-z","checkout":"TY-z","placeholder":"UY-z","account":"VY-z"};